// extracted by mini-css-extract-plugin
module.exports = {"grid":"usp-module--grid--1idoH","grid__item":"usp-module--grid__item--1pSM2"};